import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CarouselModule } from 'primeng/carousel';
import { TransformedStory } from '../../interfaces/success-story.interface';

@Component({
  selector: 'app-mobile-sme-stories',
  standalone: true,
  imports: [CommonModule, CarouselModule],
  templateUrl: './mobile-sme-stories.component.html',
  styleUrl: './mobile-sme-stories.component.scss'
})
export class MobileSmeStoriesComponent {
  @Input() smeSuccessStories: TransformedStory[] = [];
  @Output() storyClick = new EventEmitter<TransformedStory>();
  
  onStoryClick(story: TransformedStory) {
    this.storyClick.emit(story);
  }
}
